import "./index.scss";
import React from "react";

export interface ChipProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}

const Chip = ({ children, onClick }: ChipProps) => (
  <button
    className="Chip"
    type="button"
    onClick={(e) => (onClick ? onClick(e) : {})}
  >
    {children}
  </button>
);

export default Chip;
